import util from '../util';

export const DEALER = 'DEALER';
export const DEALER_STATUS = 'DEALER_STATUS';
export const DEALERS = 'DEALERS';
export const DEALER_CREATE = 'DEALER_CREATE';
export const DEALER_UPDATE = 'DEALER_UPDATE';
export const RESET_DEALER = 'RESET_DEALER';
export const DELETE_DEALER = 'DELETE_DEALER';
export const MODIFY_DEALER_TMP_STATE = 'MODIFY_DEALER_TMP_STATE';
export const INVENTORY_IMPORT = 'DEALER_INVENTORY_IMPORT';
export const DEALER_YMMT = 'DEALER_YMMT';
export const DEALER_PRICE_RULES_UPDATE = 'DEALER_PRICE_RULES_UPDATE';
export const DEALER_PRICE_RULES_FETCH = 'DEALER_PRICE_RULES_FETCH';
export const DEALER_SET_THEME = 'DEALER_SET_THEME';

export const DEALERS_REQUEST = util.requestType(DEALERS);
export const DEALERS_SUCCESS = util.successType(DEALERS);
export const DEALERS_FAILURE = util.failureType(DEALERS);

export const DEALER_REQUEST = util.requestType(DEALER);
export const DEALER_SUCCESS = util.successType(DEALER);
export const DEALER_FAILURE = util.failureType(DEALER);

export const DEALER_STATUS_REQUEST = util.requestType(DEALER_STATUS);
export const DEALER_STATUS_SUCCESS = util.successType(DEALER_STATUS);
export const DEALER_STATUS_FAILURE = util.failureType(DEALER_STATUS);

export const CREATE_DEALER_REQUEST = util.requestType(DEALER_CREATE);
export const CREATE_DEALER_SUCCESS = util.successType(DEALER_CREATE);
export const CREATE_DEALER_FAILURE = util.failureType(DEALER_CREATE);

export const UPDATE_DEALER_REQUEST = util.requestType(DEALER_UPDATE);
export const UPDATE_DEALER_SUCCESS = util.successType(DEALER_UPDATE);
export const UPDATE_DEALER_FAILURE = util.failureType(DEALER_UPDATE);

export const DELETE_DEALER_REQUEST = util.requestType(DELETE_DEALER);
export const DELETE_DEALER_SUCCESS = util.successType(DELETE_DEALER);
export const DELETE_DEALER_FAILURE = util.failureType(DELETE_DEALER);

export const MODIFY_DEALER_TMP_STATE_REQUEST = util.requestType(
  MODIFY_DEALER_TMP_STATE,
);
export const MODIFY_DEALER_TMP_STATE_SUCCESS = util.successType(
  MODIFY_DEALER_TMP_STATE,
);
export const MODIFY_DEALER_TMP_STATE_FAILURE = util.failureType(
  MODIFY_DEALER_TMP_STATE,
);

export const INVENTORY_IMPORT_REQUEST = util.requestType(INVENTORY_IMPORT);
export const INVENTORY_IMPORT_SUCCESS = util.successType(INVENTORY_IMPORT);
export const INVENTORY_IMPORT_FAILURE = util.failureType(INVENTORY_IMPORT);

export const DEALER_YMMT_REQUEST = util.requestType(DEALER_YMMT);
export const DEALER_YMMT_SUCCESS = util.successType(DEALER_YMMT);
export const DEALER_YMMT_FAILURE = util.failureType(DEALER_YMMT);

export const DEALER_PRICE_RULES_UPDATE_REQUEST = util.requestType(
  DEALER_PRICE_RULES_UPDATE,
);
export const DEALER_PRICE_RULES_UPDATE_SUCCESS = util.successType(
  DEALER_PRICE_RULES_UPDATE,
);
export const DEALER_PRICE_RULES_UPDATE_FAILURE = util.failureType(
  DEALER_PRICE_RULES_UPDATE,
);

export const DEALER_PRICE_RULES_FETCH_REQUEST = util.requestType(
  DEALER_PRICE_RULES_FETCH,
);
export const DEALER_PRICE_RULES_FETCH_SUCCESS = util.successType(
  DEALER_PRICE_RULES_FETCH,
);
export const DEALER_PRICE_RULES_FETCH_FAILURE = util.failureType(
  DEALER_PRICE_RULES_FETCH,
);

export const SET_DEALER_THEME_REQUEST = util.requestType(DEALER_SET_THEME);
export const SET_DEALER_THEME_SUCCESS = util.successType(DEALER_SET_THEME);
export const SET_DEALER_THEME_FAILURE = util.failureType(DEALER_SET_THEME);
